import React, { useState, useEffect, useRef } from "react";
import { TextField } from "@material-ui/core";
import useStyles from "./Styles";
import CustomizedSelect from "../common/CustomizedSelect";
import Autocomplete from "@material-ui/lab/Autocomplete";
import technicalActions from './actions'
import './tabpanel.css'

// Props are being passed down from ChartTitle.js
const ColoradoRiverAccessLocationFilter = ({
  location_options,
  handleChange,
  label,
  style,
  fullWidth,
  city_id,
  autocomplete, // If true the dropdown provides a search bar along with dropdown
  show = true
}) => {
  const classes = useStyles();
  const isInitialMount = useRef(true);
  const [selectedValue, setSelectedValue] = useState(1);
  const {setUserLastSelectedMapState, setEntityHeader} = technicalActions();

  const handleSelectedLocation = (e) => {
    setSelectedValue(e.target.value);
    // setUserLastSelectedMapState({
    //   center: null,
    //   zoom: null
    // });
    
  };

  const setHeader = () => {
    if(city_id && location_options?.length) {
      setEntityHeader(location_options, city_id)
    }
  }

  useEffect(setHeader, [city_id])

  const handleAutoCompleteLocation = (e, v) => {
    if (v !== null){
      handleChange(v.value);
      //if location is changed reset the user last selected map state
      setUserLastSelectedMapState({
      center: null,
      zoom: null
    });
    } 
    
  };

  location_options.sort((a, b) => a.label.localeCompare(b.label));
  // console.log(location_options);

  // useEffect(() => {
  //   if (isInitialMount.current) {
  //     isInitialMount.current = false;
  //   } else {
  //     handleChange(selectedValue);
  //     // console.log("selected value", selectedValue);
  //   }
  // }, [selectedValue]);

  // This is for the public view - to update the location filter to match the other cty dropdowns.
  const setCityID = () => {
    if (selectedValue !== city_id && !isInitialMount.current) {
      console.log("selected value", selectedValue, city_id);
      setSelectedValue(city_id);
    }
    // setUserLastSelectedMapState({
    //   center: null,
    //   zoom: null
    // });
  }
  useEffect(setCityID, [city_id]);

  if (show) {
    return (
      // <Box className={classes.locationFilterBox}>
      <div className={classes.mapLocationDiv} style={style}>
        {autocomplete ? (
          // Added Autocomplete component instead of CustomizedSelect since it provides
          // searchbar along with dropdown
          // Check https://asudev.jira.com/browse/CURVE-369 for more info
          <Autocomplete
            id="sidebar-location-select"
            value={
              location_options.find((location) => location.value === city_id) ||
              {}
            }
            options={location_options}
            getOptionLabel={(option) => option.label || ""}
            onChange={handleAutoCompleteLocation}
            style={{ marginRight: 24 }}
            fullWidth={fullWidth}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label={label} 
                variant="outlined"
              />
            )}
          />
        ) : (
          <CustomizedSelect
            label={label}
            fullWidth={fullWidth}
            dropdownValue={selectedValue}
            options={location_options}
            handleSelectedItem={handleSelectedLocation}
            type="location"
          />
        )}
      </div>
  
      // </Box>
    );
  } else {
    return null
  }
};

ColoradoRiverAccessLocationFilter.defaultProps = {
  label: "",
  fullWidth: false,
  autocomplete: false,
  show: true,
};

export default ColoradoRiverAccessLocationFilter;
